export const MONTH_MAP: { [key: string]: string } = {
  January: '01',
  February: '02',
  March: '03',
  April: '04',
  May: '05',
  June: '06',
  July: '07',
  August: '08',
  September: '09',
  October: '10',
  November: '11',
  December: '12',
};

export const ONBOARDING_STEP_KEY = 'onboarding_current_step';

export const GROUP_TYPE = {
  GENERIC: 1,
  CUSTOM: 2,
  SET: 3,
} as const;

export const GROUP_TYPES: Record<number, string> = {
  1: 'Generic',
  2: 'Custom',
  3: 'SET',
};

export const WEB_CLIENT_TYPE = {
  GENERIC: 1,
  CUSTOM: 2,
  // Mirrors virgil `WebClientType.SmallEmployerTenant` (= 3): the W2/small-employer
  // tenant KIND. A group host with this webClientType is a "W2 host" — token-less
  // B2C surfaces are locked down there (see `features/w2/host`).
  SMALL_EMPLOYER_TENANT: 3,
} as const;

export const ACCEPTANCE_WARNING_LS_KEY = 'acceptanceWarning:hide';
export const TOUR_LS_KEY = 'tour:hide';
export const UNDER_REVIEW_LS_KEY = 'underReview:hide';
export const EXPIRED_EFFECTIVE_DATE_LS_KEY = 'expiredEffectiveDate:checked';

// Primary applicant's zip/phone entered on the Myself step (client-side backup)
export const ONBOARDING_ZIP_LS_KEY = 'onboarding_myself_zip';
export const ONBOARDING_PHONE_LS_KEY = 'onboarding_myself_phone';
